// extracted by mini-css-extract-plugin
module.exports = {"bpMedium":"(min-width: 768px)","bpXLarge":"(min-width: 1160px)","hero":"styles-module--hero--2Vlyv shared--clearfix--1mZ9s"};